export const IOS_PORTRAIT_ONLY_VERSION = '10.16.0' as const;
